import BigNumber from 'bignumber.js'

export function rewardsAreActive(availableRewards, startBlock, currentBlock){
    const DUST = 1000000000000000000  
    if(new BigNumber(availableRewards).gt(DUST) && currentBlock > startBlock){
      return true
    }
    return false
  }
